
import React, { useState, useEffect } from "react";
import { Button } from "../Common.jsx";
import { DynamicIcon } from "../icons.jsx";

const QuotaCard = ({ title, value, unit, icon, colorClass, onChange }) => (
  <div className="bg-white dark:bg-gray-800 border dark:border-gray-700 rounded-xl p-5 shadow-sm relative overflow-hidden group hover:border-primary/50 transition-colors">
    <div className={`absolute top-0 right-0 p-3 opacity-10 group-hover:opacity-20 transition-opacity ${colorClass}`}>
      <DynamicIcon name={icon} className="w-24 h-24" />
    </div>

    <div className="relative z-10 flex flex-col h-full justify-between">
      <div className="flex items-center gap-2 mb-4">
        <div className={`p-2 rounded-lg ${colorClass} bg-opacity-20 text-current`}>
          <DynamicIcon name={icon} className="w-5 h-5" />
        </div>
        <h4 className="font-semibold text-gray-700 dark:text-gray-200">{title}</h4>
      </div>

      <div>
        <div className="flex items-baseline gap-1">
          <input
            type="number"
            value={value || ""}
            onChange={onChange}
            className="text-3xl font-bold bg-transparent border-b border-gray-200 dark:border-gray-700 focus:border-primary focus:outline-none w-full py-1 text-gray-900 dark:text-white placeholder-gray-300"
            placeholder="0"
          />
          <span className="text-gray-500 font-medium text-sm">{unit}</span>
        </div>
      </div>
    </div>
  </div>
);

export default function QuotaConfigForm({ data, onSave, token, onNext }) {
  const [form, setForm] = useState({
    api_call_limit: data?.api_call_limit ?? "",
    user_limit: data?.user_limit ?? "",
  });

  useEffect(() => {
    setForm({
      api_call_limit: data?.api_call_limit ?? "",
      user_limit: data?.user_limit ?? "",
    });
  }, [data]);

  const sanitize = (d) => ({
    api_call_limit: d.api_call_limit !== "" ? Number(d.api_call_limit) : null,
    user_limit: d.user_limit !== "" ? Number(d.user_limit) : null,
  });

  const handleSave = async () => {
    await onSave(sanitize(form));
    if (onNext) onNext();
  };

  return (
    <div className="space-y-6">
      <h3 className="text-lg font-bold text-gray-800 dark:text-white">Resource Guardrails</h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <QuotaCard
          title="Monthly Credits"
          unit="/ month"
          value={form.api_call_limit}
          onChange={(e) => setForm({ ...form, api_call_limit: e.target.value })}
          icon="Coins"
          colorClass="text-yellow-600 bg-yellow-600"
        />

        <QuotaCard
          title="Max Users"
          unit="Concurrent"
          value={form.user_limit}
          onChange={(e) => setForm({ ...form, user_limit: e.target.value })}
          icon="Users"
          colorClass="text-purple-600 bg-purple-600"
        />
      </div>

      <div className="sticky bottom-0 z-10 bg-white/90 dark:bg-gray-800/90 backdrop-blur border-t dark:border-gray-700 p-4 -mx-6 -mb-6 mt-8 flex justify-end shadow-lg rounded-b-xl">
        <Button onClick={handleSave} className="px-6 shadow-md">
          Save &amp; Next <DynamicIcon name="ArrowRight" className="ml-2 w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
